import React, { Component } from 'react'
import { Button, Modal, Col, Form } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../../components/commons/form/InputSelect'
import { fleetMode } from '../../../constants/dossier/common/documentEditionModal'
import { handleKeyDown } from '../../../util/utils'

class SignTypesModal extends Component {
  constructor (props) {
    super()
    this.state = {
      buttonDisabled: true
    }
    this.required = this.required.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  signTypeActionPromise (values) {
    return new Promise((resolve, reject) => {
      if (this.props.fleetMode === fleetMode.REQUEST_SIGN) {
        return this.props.actions.createRequestSignDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, values.signTypeId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
      } else {
        return this.props.actions.requestSign(this.props.documentId, null, this.props.callback, this.props.refreshAfterChange, values.signTypeId, resolve, false, null, this.props.dossierType, this.props.updateDossierAction, this.props.dossierParentId)
      }
    })
  }

  signTypeAction (values) {
    if (values) {
      this.signTypeActionPromise(values)
      this.props.closeModalAction()
    }
  }

  required (value) {
    if (!value) {
      return this.props.t('GLOBAL.FORMS.REQUIRED')
    } else {
      return undefined
    }
  }

  onInputChange (value) {
    value ? this.setState({ buttonDisabled: false }) : this.setState({ buttonDisabled: true })
  }

  render () {
    const { t, handleSubmit, showModal, closeModalAction, signTypesCombo } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SIGN_TYPES_MODAL.'
    return (
      <Modal id='SignTypesModal' className='_nf' show={showModal} onHide={() => closeModalAction()}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.signTypeAction.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {signTypesCombo && signTypesCombo.length > 0 && <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="signTypeId"
                name="signTypeId"
                placeholder={t(`${tKey}PLACEHOLDER`)}
                options={signTypesCombo}
                valueKey="id"
                labelKey="value"
                validate={[this.required]}
                onInputChange={this.onInputChange}
              />}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col className="flexInLine al-C">
              <Button id="btn_save" disabled={this.state.buttonDisabled} className="_Btn accept" type="submit">{t(`${tKey}ACCEPT`)}</Button>
            </Col>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const error = {}
  return error
}

export default reduxForm({
  form: 'sign_types_modal',
  validate
})(SignTypesModal)
